import { Component, Input, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FilterListModel, FilterSubsListObj } from 'src/app/models/filter-list-model';
import { UserDetails } from 'src/app/models/user-details.model';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';

@Component({
  selector: 'ipm-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  currentYear: any = "2023"
  paymentList:Array<string> =  [
    "online-card.svg",
    "upi-payment-icon.svg",
    "discover-card-icon.svg",
    "credit-card-icon.svg",
    "visa-icon.svg",
    "american-card-icon.svg"
  ];
  @Input() currentUserDetails: UserDetails;
  @Input() isMusicPlayerOpen: boolean = false;
  @Input() genreList: Array<any> = [];
  menuList: Array<any> = [];
  mainLogoImageUrl: string = "https://ip-dev.s3.ap-south-1.amazonaws.com/assets/imgs/footer-icons/logo-main.svg";
  @Output() triggerClickEvent: EventEmitter<any> = new EventEmitter();
  /** Diwali sale banner above the footer: Pro plan price and its Diwali price */
  readonly proPlanPrice: number = 4999;
  readonly proPlanSalePrice: number = 3999;
  constructor(public commonService: CommonService,
    private router: Router,
    private ga4Tracking: Ga4trackingService,
    private subscriptionService: SubscriptionService) {
      let currentDate = new Date().getFullYear();
      if (currentDate) {
        this.currentYear =  currentDate;
      }

      if (this.commonService.isNewBeatLogoEnable) {
        this.mainLogoImageUrl = "https://ip-dev.s3.ap-south-1.amazonaws.com/assets/imgs/beat22-logo/main-logo-beat22.svg";
      }
    }

  ngOnInit(): void {
    this.prepareMenuList();
  }

  /** Diwali Pro offer banner: while the sale is live, and not for users already on Pro Annual */
  get showSaleBanner(): boolean {
    return this.commonService.isSaleActive() && !this.subscriptionService.isOnProAnnual();
  }

  /** End date of the active sale (platform-sale/active API) */
  get saleEndAt(): string | null {
    return this.commonService.getActivePlatformSale()?.end_at || null;
  }

  /** Diwali sale banner: open the Pro plans */
  openProPlans(): void {
    this.router.navigate(['/subscriptions']);
  }

  prepareMenuList() {
    this.menuList = [
      {
        heading:"Genres",
        menuList: this.genreList
      },
      {
        heading:"Company",
        menuList: [
          {
            name: "Terms & Conditions",
            routerName: "/terms-conditions"
          },
          {
            name: "Privacy Policy",
            routerName: "/privacy-policy"
          },
          {
           name: "Refund Policy",        
           routerName: "/refund-policy"  
          },
          {
            name: "Contact Us",
            routerName: "/contact-us"
          },
          {
            name: "About Us",
            routerName: "/about-us"
          }
        ]
      }
    ];
    let supportArray: Array<any> = [];
    if(!this.currentUserDetails) {
      supportArray.push({
        name:"Sign Up",
        routerName: ""
      },{
        name:"Sign In",
        routerName: "Start Selling",
      },
      {
        name:"Start Selling",
        routerName: ""
      });
    } else  {
      if (this.currentUserDetails.role !== "producer") {
        supportArray.push({
          name:"Start Selling",
          routerName: ""
        });
      }
    }
    supportArray.push({
      name:"License Blog",
      routerName: ""
    },
    {
      name:"WhatsApp Support",
      routerName: ""
    },{
       name:"Help Desk",
       routerName: ""
    });

    this.menuList.push({
        heading:"Support",
        menuList: supportArray
    },
    {
      heading:"Explore",
      menuList: [
        {
          name: "WAV under ₹999",
          routerName: "",
          key: "wav_under_999"
        },
        {
          name: "Wav + Stems under ₹1,999",
          routerName: "",
          key: "wav_stems_1999"
        },
        {
          name: "Beat With Exclusive",
          routerName: "",
          key: "beats_with_exclusives"
        },
        {
          name: "Trending Beats",
          routerName: "/trending-beats"
        },
        {
          name:"Blog",
          routerName: ""
        }
      ]
    })
  }

  onChangeSearchValue(event: any) {
    if (this.commonService.selectedSearchInputValue && this.commonService.selectedSearchInputValue.trim()) {
      this.commonService.sendSearchDataUrl(this.commonService.selectedSearchInputValue, "search");
    }
  }

  openBeatSelling() {
    this.handleNavigationClick('Support', {
      name:"Start Selling",
      routerName: ""
    });
  }

  handleNavigationClick(parentKeyName: string, menuListData: any) {
    const userRole = this.currentUserDetails?.role || 'guest';
    const userId = this.currentUserDetails?._id || 'guest';
    // Tutorials
    if (menuListData.name === 'Tutorials') {
      let eventName = 'click_tutorials';
      let attributes = {
        category: 'Beats',
        label: 'Engagement',
        action: 'click',
        userRole,
        userId,
      };
      this.ga4Tracking.sendEvent(eventName, attributes);
     
    }
    // Help Desk
    if (menuListData.name === 'Help Desk' || menuListData.name === 'Helpdesk') {
      let eventName = 'click_helpdesk';
      let attributes = {
        category: 'Beats',
        label: 'Engagement',
        action: 'click',
        userRole,
        userId,
      };
      this.ga4Tracking.sendEvent(eventName, attributes);
     
    }
    // Blog
    if (menuListData.name === 'License Blog' || menuListData.name === 'License Blogs') {
      let eventName = 'click_blogs';
      let attributes = {
        category: 'Beats',
        label: 'Engagement',
        action: 'click',
        userRole,
        userId,
      };
      this.ga4Tracking.sendEvent(eventName, attributes);
     
    }
    // WhatsApp Support
    if (menuListData.name === 'WhatsApp Support' || menuListData.name?.toLowerCase().includes('whatsapp')) {
      let eventName = 'click_whatsappsupport';
      let attributes = {
        category: 'Beats',
        label: 'Engagement',
        action: 'click',
        userRole,
        userId,
      };
      this.ga4Tracking.sendEvent(eventName, attributes);
     
    }
    switch(parentKeyName) {
      case "Genres":
        this.commonService.applyGenreFilters(menuListData.key,'key');
        break;
      case "Support":
        if (menuListData.name === "Sign Up" || menuListData.name === "Sign In") {
          this.triggerClickEvent.emit(menuListData.name === "Sign Up" ? 'signup' : 'login' );
        } else if (menuListData.name === "Start Selling") {
          if ((this.currentUserDetails && this.currentUserDetails.role !== "producer") || !this.currentUserDetails) {
            this.triggerClickEvent.emit('start_selling');
          }
        } else if (menuListData.name === "WhatsApp Support") {
          this.commonService.openSupport();
        } else if (menuListData.name === "Help Desk") {
          window.open("https://help.beat22.com", "_blank");
        }else if(menuListData.name === 'License Blog' ){
          this.commonService.openLicenseBlog();
        } else {
          if (menuListData.routerName) {
              this.router.navigate([menuListData.routerName])
            }
        }
        break;
      case "Company":
        this.router.navigate([menuListData.routerName]);
        break;
      default:
        if (!menuListData.routerName) {
          if (parentKeyName === "Explore" && menuListData.name === "Blog") {
            window.open("https://blog.beat22.com", "_blank");
          } else {
            this.selectedCategory(menuListData.key);
          }
        } else {
          this.router.navigate([menuListData.routerName])
        }
        break;
    }
  }

  selectedCategory(filterKeyName: string) {
    this.commonService?.filterOptionList.filter((filterObj:FilterListModel) => {
      if (filterObj.filter_type === 'swipes-menu') {
         filterObj.filter_sub_list.filter((subFilterObj: FilterSubsListObj) => {
           if (subFilterObj['key'] === filterKeyName) {
              subFilterObj.isSelected = true;
           }
           return subFilterObj
         });
      }
      return filterObj;
    });
    this.commonService.sendSearchDataUrl("", 'filter');
  }

}
